// We only want a failed marketplace fetch to surface as an error in production. There, a thrown
// error makes Next serve the stale ISR page and retry regeneration, so the CDN never caches an
// empty result. In preview (PR prerenders) and local/dev we instead degrade to an empty default so
// a flaky backend can't fail the whole build.
export const IS_PRODUCTION_DEPLOYMENT = process.env.NEXT_PUBLIC_ENV === 'production'
